import { Formik } from 'formik';
import {
  AppDatePicker,
  AppRemixIcon,
  AppSingleSelect,
  AppTextArea,
  AppInput,
  AppFileUploader,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../components/helpers/Translator';
import AppFileUploaderList from '../../../../../components/form/File/AppFileUploaderList';

export default function EvaluationHome({
  inspection,
  validationSchema,
  evaluationOptions,
  selectedEvaluation,
  onSave,
  onCancel,
}) {
  const handleUpload = (values, setFieldValue, opt) => {
    const files = Array.from(opt);
    setFieldValue('files', [...values.files, ...files]);
  };

  return (
    <Formik
      initialValues={{
        evaluationID: selectedEvaluation?.id ?? null,
        evaluation: selectedEvaluation?.evaluation ?? null,
        evaluationDateStamp: selectedEvaluation?.evaluationDateStamp ?? null,
        nonConformityCode: selectedEvaluation?.nonConformityCode ?? '',
        acceptanceCriteria: selectedEvaluation?.acceptanceCriteria ?? '',
        comment: selectedEvaluation?.comment ?? '',
        files: [],
        deletedFiles: [],
      }}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={onSave}
    >
      {({ handleSubmit, values, setFieldValue, isSubmitting, errors }) => (
        <form onSubmit={handleSubmit} className="p-2">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <span
                  className="float-right pointer mr-2"
                  title={ReactDOMServer.renderToString(
                    <Translator file="module-legalCompliance" name="close" />,
                  )}
                >
                  <AppRemixIcon icon="close" size={16} onClick={onCancel} />
                </span>
              </div>
            </div>
            {inspection.acceptanceCriteria && (
              <div className="row">
                <div className="col-lg-12">
                  <div className="alert alert-info">
                    {inspection.acceptanceCriteria}
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-lg-12">
                <AppSingleSelect
                  title="Evaluación"
                  options={evaluationOptions}
                  onChange={(value) => setFieldValue('evaluation', value)}
                  value={values.evaluation}
                  error={errors?.evaluation}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <AppInput
                  title="Código no conformidad"
                  onChange={(value) => setFieldValue('nonConformityCode', value)}
                  value={values.nonConformityCode}
                  error={errors?.nonConformityCode}
                  required={values?.evaluation === 2}
                />
              </div>
              <div className="col-lg-6">
                <AppDatePicker
                  title="Fecha evaluación"
                  value={values?.evaluationDateStamp}
                  error={errors?.evaluationDateStamp}
                  placeholder="DD/MM/YYYY"
                  onChange={(opt) => setFieldValue('evaluationDateStamp', opt)}
                  isClearable
                  showYearDropdown
                  showMonthDropdown
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <AppTextArea
                  title="Comentario"
                  onChange={(opt) => setFieldValue('comment', opt)}
                  value={values.comment}
                  error={errors?.comment}
                  height="36px"
                  resize
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <AppFileUploaderList
                  values={values}
                  setFieldValue={setFieldValue}
                  urlsAvaliable={selectedEvaluation?.files}
                  showIconWhenEMpty={false}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <AppFileUploader
                  placeholder={
                    values.files.length === 0
                      ? ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="select.one.multiple.files"
                          />,
                        )
                      : ReactDOMServer.renderToString(
                          <Translator
                            file="general"
                            name="select.number.of.elements"
                            variables={{ elements: values.files.length }}
                          />,
                        )
                  }
                  onChange={(opt) => handleUpload(values, setFieldValue, opt)}
                  btnText={<Translator file="general" name="search..." />}
                  isMulti
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <button
                  type="submit"
                  className="btn btn-primary btn-xs float-right mt-2 mb-2"
                  disabled={isSubmitting}
                >
                  {selectedEvaluation ? 'Editar evaluación' : 'Nueva evaluación'}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}
